const getCompleteLessonsQty = (moduleData, sfccModule) => {
    const builderLessons = moduleData.lessons
    const sfccLessons = sfccModule?.lessons || []
    const isQuizComplete = !!sfccModule?.quiz?.complete

    let completeLessonsQty = builderLessons.reduce((totalQty, builderLesson) => {
        const lessonID = builderLesson.lesson.value.data.id
        const isLessonComplete = sfccLessons.some((sfccLesson) => sfccLesson.id === lessonID)

        return totalQty + (isLessonComplete ? 1 : 0)
    }, 0)

    if (isQuizComplete) completeLessonsQty++

    return completeLessonsQty
}

const buildModules = (levelData, sfccLevel) => {
    const builderModules = levelData.modules
    const sfccModules = sfccLevel?.modules || []

    return builderModules.map((builderModule, moduleIndex) => {
        const moduleData = builderModule.module.data
        const moduleID = moduleData.id
        const sfccModule = sfccModules.find((module) => module.id === moduleID)

        return {
            moduleID: moduleData.id,
            moduleNumber: moduleIndex + 1,
            title: moduleData.title,
            image: moduleData.image,
            estimatedCompletionTime: moduleData.estimatedCompletionTime,
            allLessonsQty: moduleData.lessons.length + 1, // +1 because of quiz
            completeLessonsQty: getCompleteLessonsQty(moduleData, sfccModule),
            complete: !!sfccModule?.complete,
            started: !!sfccModule?.start
        }
    })
}

const createLevels = (goalData, sfccGoal) => {
    if (!goalData) return []
    const builderLevels = goalData.levels

    return builderLevels.map((builderLevel, levelIndex) => {
        const levelData = builderLevel.level.value.data
        const levelID = levelData.id
        const sfccLevel = sfccGoal?.levels.find((level) => level.id === levelID)

        return {
            levelID: levelData.id,
            levelNumber: levelIndex + 1,
            title: levelData.title,
            modules: buildModules(levelData, sfccLevel),
            started: !!sfccLevel?.start
        }
    })
}

export default createLevels
